import { render, staticRenderFns } from "./CallForwarding.vue?vue&type=template&id=55d3f0e7&"
import script from "./CallForwarding.vue?vue&type=script&lang=js&"
export * from "./CallForwarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports